<div class="flex justify-between items-center mb-4 mt-4">
  <div class="flex flex-1">
    <div class="flex w-72">
      <elcia-search [control]="searchControl"/>
    </div>
  </div>
  <div class="flex flex-1 justify-center">
    <elcia-period-navigator (periodChange)="setPeriod($event)" [initialDate]="periodStore.period().startDate"/>
  </div>
  <div class="flex flex-1 flex-row-reverse gap-2">
    <elcia-button (onClick)="navToForm()" [icon]="'plus'" [label]="'credit-note.add' | translate"/>
  </div>
</div>

<p-table [scrollable]="true" [size]="'small'" [value]="creditNotes()" scrollHeight="flex">
  <ng-template #header>
    <tr>
      <th pSortableColumn="number">{{ 'invoice.number' | translate }}
        <p-sortIcon field="number"/>
      </th>
      <th pSortableColumn="customerName">{{ 'entity.customer' | translate }}
        <p-sortIcon field="customerName"/>
      </th>
      <th pSortableColumn="legalEntityName">{{ 'entity.legal-entity' | translate }}
        <p-sortIcon field="legalEntityName"/>
      </th>
      <th pSortableColumn="date">{{ 'invoice.invoice-date' | translate }}
        <p-sortIcon field="date"/>
      </th>
      <th pSortableColumn="amountWithoutTax">{{ 'invoice.total-without-taxes' | translate }}
        <p-sortIcon field="amountWithoutTax"/>
      </th>
      <th>{{ 'invoice.status' | translate }}</th>
    </tr>
  </ng-template>
  <ng-template #body let-creditNote>
    <tr (click)="select(creditNote)" [class.cursor-pointer]="isDraft(creditNote)">
      <td>{{ creditNote.number }}</td>
      <td>{{ creditNote.customerName }}</td>
      <td>{{ creditNote.legalEntityName }}</td>
      <td>{{ creditNote.date | date:'dd/MM/yyyy' }}</td>
      <td>{{ creditNote.amountWithoutTax | currency:'EUR' }}</td>
      <td>
        <span class="inline-flex text-xs font-bold rounded-full py-0.5 px-2 whitespace-nowrap"
              [class]="creditNote.stateName === CreditNoteStateId.SENT ? 'bg-green-100 text-green-700' : 'bg-[var(--p-surface-200)] text-surface-600'">
          {{ ('credit-note.state.' + creditNote.stateName) | translate }}
        </span>
      </td>
    </tr>
  </ng-template>
</p-table>
